import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ReportGroup } from '../../_models/reports';

@Injectable({
  providedIn: 'root'
})
export class ReportFavoriteService {
  private availableReports = new BehaviorSubject<ReportGroup[]>([]);
  private favoriteGroups = new BehaviorSubject<ReportGroup[]>([]);
  private favoriteReports = new BehaviorSubject<ReportGroup>({
    reportGroup: "Favorite Reports",
    reports: [],
    reportGroupID: 0
  });
  private totalReports = new BehaviorSubject<ReportGroup>({
    reportGroup: "Total Reports",
    reports: [],
    reportGroupID: 0
  });
  private noFavoriteReports = new BehaviorSubject<boolean>(false);
  private favoriteErrorMessage = new BehaviorSubject<string>(null);
  private queryReport = new Subject<string>();

  constructor() {
  }

  availableReports$ = this.availableReports.asObservable();
  favoriteGroups$ = this.favoriteGroups.asObservable();
  favoriteReports$ = this.favoriteReports.asObservable();
  totalReports$ = this.totalReports.asObservable();
  noFavoriteReports$ = this.noFavoriteReports.asObservable();
  favoriteErrorMessage$ = this.favoriteErrorMessage.asObservable();
  queryReport$ = this.queryReport.asObservable();

  updateAvailableReports(updatedValue: ReportGroup[]) {
    this.availableReports.next(updatedValue);
  }

  updateFavoriteGroups(updatedValue: ReportGroup[]) {
    this.favoriteGroups.next(updatedValue);
  }

  updateFavoriteReports(updatedValue: ReportGroup) {
    this.favoriteReports.next(updatedValue);
  }

  updateTotalReports(updatedValue: ReportGroup) {
    this.totalReports.next(updatedValue);
  }

  setNoFavoriteReportsStatus(updatedStatus: boolean) {
    this.noFavoriteReports.next(updatedStatus);
  }

  setFavoriteErrorMessage(updatedMessage: string) {
    this.favoriteErrorMessage.next(updatedMessage);
  }

  upddateQueryReport(updatedQuery: string) {
    this.queryReport.next(updatedQuery);
  }
}
